/** Auth-only stubs — Meta pixel is optional and non-blocking. */

const newEventId = (): string => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  // Fallback UUID v4 (non-crypto environments only).
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * Browser Meta context for register/login. `eventId` MUST be a UUID —
 * `metaEventContextSchema` rejects non-UUID values (API 400 validation_failed).
 */
export const buildMetaEventContext = (_opts?: unknown) =>
  ({
    eventId: newEventId(),
    marketingConsent: false,
  }) as {
    eventId: string;
    marketingConsent: boolean;
    fbp?: string;
    fbc?: string;
    eventSourceUrl?: string;
    value?: number;
    currency?: string;
  };

export const trackMetaEvent = async (
  _event?: unknown,
  _payload?: unknown,
  _eventId?: unknown,
) => {
  /* no-op in auth slice */
};
